import { createSlice } from "@reduxjs/toolkit";
import { trainer , trainerState } from "./tarinertype";
import { createTrainer , updatetrainer , gettrainerById , fetchAlltrainer  , deletetrainerById} from "./trainerAction";
import { BulbFilled } from "@ant-design/icons";


const  initialState : trainerState ={
    trainer : [],
    selected : undefined,
    loading : false,
    error : undefined,

}

const trainerSlice = createSlice({
    name : 'trainer',
    initialState ,
    reducers: {},
    extraReducers : (builder) =>{
       builder
         .addCase(createTrainer.pending,(state) =>{
                     state.loading = true;
                     state.error =undefined;
                   })
                   .addCase(createTrainer.fulfilled, (state, action) => {
                                     state.loading = false;
                                     state.trainer.push(action.payload.data)
                                   })
                   .addCase(createTrainer.rejected, (state, action) => {
                                     state.loading = false;
                                     state.error = action.payload as string;
                            })
                 //update
                          .addCase(updatetrainer.pending,(state , action) =>{
                                  state.loading=true ;
                                  state.error = undefined;
                          })
                          .addCase(updatetrainer.fulfilled, (state, action) => {
                                state.loading = false;
                                const index = state.trainer.findIndex((d : any) => d.Id === action.payload.Id);
                                if (index !== -1) {
                                    state.trainer[index] = action.payload;
                                }
                         })
                          .addCase(updatetrainer.rejected, (state, action) => {
                           state.loading = false;
                           state.error = action.payload as string;
                        })   
                        
            //fetch all
                   .addCase(fetchAlltrainer.pending,(state , action) =>{
                    state.loading=true ;
                    state.error = undefined;
                  })
                  .addCase(fetchAlltrainer.fulfilled, (state, action) => {
                  state.loading = false;
                  state.trainer=action.payload.data
                  })
                 .addCase(fetchAlltrainer.rejected, (state, action) => {
                 state.loading = false;
                 state.error = action.payload as string;
                 })
            
                 // Fetch  by ID
                 .addCase(gettrainerById.pending, (state) => {
                   state.loading = true;
                   state.error = undefined;
                   })
                   .addCase(gettrainerById.fulfilled, (state, action) => {
                       state.loading = false;
                       state.trainer = action.payload;
                   })
                   .addCase(gettrainerById.rejected, (state, action) => {
                       state.loading = false;
                       state.error = action.payload as string;
                   })
            
            
                   .addCase(deletetrainerById.pending, (state) => {
                        state.loading = true;
                        state.error = undefined;
                    })
                    .addCase(deletetrainerById.fulfilled, (state, action) => {
                         state.loading = false;
                         state.trainer = state.trainer.filter((d : any) => d.Id !== action.payload);
                     })
                     .addCase(deletetrainerById.rejected, (state, action) => {
                        state.loading = false;
                        state.error= action.payload as string;
                     })     
    }
})



export default trainerSlice.reducer;